// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SelectionResultOverviewItem-module-container-1pOMR{display:flex;flex-wrap:nowrap;gap:10px}.SelectionResultOverviewItem-module-header-3emXI{order:2;display:flex;flex-direction:column;justify-content:center}.SelectionResultOverviewItem-module-headline-ofa8L{color:#2d2926;font-size:16px;font-style:normal;font-weight:var(--weight-light);line-height:20px}.SelectionResultOverviewItem-module-flavorDescription-mc1RP{color:#373a36;font-size:12px;font-style:normal;font-weight:var(--weight-light);line-height:normal}.SelectionResultOverviewItem-module-image-2I2TV{width:35px;height:35px;margin:3.5px;order:1;background:rgba(0,0,0,0) no-repeat center;background-size:contain}", ""]);
// Exports
exports.locals = {
	"container": "SelectionResultOverviewItem-module-container-1pOMR",
	"header": "SelectionResultOverviewItem-module-header-3emXI",
	"headline": "SelectionResultOverviewItem-module-headline-ofa8L",
	"flavorDescription": "SelectionResultOverviewItem-module-flavorDescription-mc1RP",
	"image": "SelectionResultOverviewItem-module-image-2I2TV"
};
module.exports = exports;
